import { ScenarioStep, Steps } from '../state/interfaces'
import { provinces } from './common-steps'
import { buyOrBringPhone, howManyCallingMinutes, howMuchData } from './mobile-steps'

export const provincesStep = {
  ...provinces,
  next: Steps.HOW_MANY_CALLING_MINUTES,
}

export const howManyCallingMinutesStep = {
  ...howManyCallingMinutes,
  next: Steps.HOW_MUCH_DATA,
}

export const howMuchDataStep = {
  ...howMuchData,
  next: Steps.BUY_OR_BRING_PHONE_QUICK_SEARCH,
}

export const buyOrBringPhoneQuickSearch: ScenarioStep = {
  ...buyOrBringPhone,
  id: Steps.BUY_OR_BRING_PHONE_QUICK_SEARCH,
  question: 'buy-or-bring-phone-quick-search_question',
}
